import { render, staticRenderFns } from "./admin-users-list.vue?vue&type=template&id=09d64997&"
import script from "./admin-users-list.vue?vue&type=script&lang=js&"
export * from "./admin-users-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports